export const profileMenu = {
    myDashboard: 'PROFILE_MENU.MY_DASHBOARD',
    billing: 'PROFILE_MENU.BILLING',
    logout: 'PROFILE_MENU.LOGOUT',
    accountSettings: 'PROFILE_MENU.ACCOUNT_SETTINGS'
};
